import { Injectable, Inject } from "@angular/core";
import {
  KreFormFieldConfig,
  KreFormFieldRole,
  KreFormFieldOption,
} from "../components/kre-form.field.config";
import {
  tap,
  catchError,
  distinctUntilChanged,
  throttleTime,
} from "rxjs/operators";
import * as _ from "lodash";
@Injectable()
export class KreFormCommonService {
  private pIndex: any = {};
  initFormFieldProperty(fields: KreFormFieldConfig[]) {
    fields.forEach((field) => {
      this.deleteFieldProperty(field);
    });
  }

  /*
    初始化Form表单字段信息
    fields: 字段数组
    role: 角色 {"key1":{"show": true,"edit": true,"required": true,"enableInterface":true,"modalField":["key1","key2"]}}
    option: 选项 {"key1":[{"value":"a","label":"选项1"},{"value":"b","label":"选项2"}]}
    model: 填充数据
    platform:mobile|pc
  */
  initFormFieldConfig(
    fields: KreFormFieldConfig[],
    role: any,
    option: any,
    model: any,
    caller?: any,
    callback?: any,
    platform?: string,
    index?: number,
    isPIndex?: boolean
  ) {
    if (!!fields && !_.isEmpty(fields)) {
      fields!.forEach((field) => {
        this.setFieldsProperty(
          field,
          role,
          option,
          model,
          caller,
          callback,
          platform,
          index,
          isPIndex
        );
      });
    }
  }

  initFormFieldModel(fields: KreFormFieldConfig[], model: any) {
    fields.forEach((field) => {
      if (field.hasOwnProperty("fieldArray")) {
        if (field.fieldArray.hasOwnProperty("fieldGroup")) {
          if (model[field.key] === undefined) {
            model[field.key] = [{}];
          }

          // field.fieldArray.fieldGroup.forEach((fieldGroup) => {});
        }
      } else {
        if (field.hasOwnProperty("editor")) {
          if (this.checkFieldDefaultValue(field)) {
            if (model[field.key] === undefined) {
              model[field.key] = field.defaultValue;
            }
          }
        }
      }
      if (
        field.type === "panel" ||
        field.type === "tabular" ||
        field.type === "salary"
      ) {
      } else {
        if (field.hasOwnProperty("fieldGroup")) {
          //初始化值
          if (!this.checkFieldDefaultValue(field)) {
            model[field.key] = {};
          }

          field.fieldGroup.forEach((fieldGroup) => {
            if (fieldGroup.hasOwnProperty("editor")) {
              if (
                this.checkFieldDefaultValue(model[field.key][fieldGroup.key])
              ) {
                model[field.key][fieldGroup.key] = fieldGroup.defaultValue;
              }
            }
          });
        }
      }
    });
  }

  //初始化表单序号
  initSurveyFormFieldConfig(surveyInfo: any) {
    surveyInfo.queTotal = 0;
    if (surveyInfo.pages) {
      surveyInfo.pages.forEach((page: any) => {
        this.setFieldNumber(surveyInfo, page.questions);
      });
    }
  }

  /**
   * 设置规则
   * @param fields
   * @param model
   * @param rule
   */
  setRuleExecuteConfig(fields: KreFormFieldConfig[], model: any, rule: any) {
    if (rule && rule !== null && typeof rule === "object") {
      for (let key in rule) {
        // let code = key;
        let item = rule[key];
        if (model == undefined || model == null) {
          model = {};
        }
        if (fields && fields.length > 0) {
          fields.forEach((field: any) => {
            this.setFiledRuleExecute(field, model, key, item, null);
          });
        }
      }
    }
  }

  /**
   * 设置角色
   * @param fields
   * @param model
   * @param role
   */
  setRoleExecuteConfig(fields: KreFormFieldConfig[], model: any, role: any) {
    if (role && role != null && typeof role === "object") {
      for (let key in role) {
        let code = key;
        let item = role[key];
        if (model == undefined || model == null) {
          model = {};
        }
        this.setFiledRoleExecute(fields, model, code, item);
      }
    }
  }

  private checkFieldDefaultValue(field: KreFormFieldConfig) {
    let result = false;
    if (
      field !== undefined &&
      field !== null &&
      field.defaultValue !== undefined &&
      field.defaultValue !== null
    ) {
      return true;
    }
    return result;
  }

  private deleteFieldProperty(field: any) {
    if (field.hasOwnProperty("status")) {
      delete field.status;
    }

    if (field.hasOwnProperty("guid")) {
      delete field.guid;
    }
    // if (field.hasOwnProperty("id")) {
    //   delete field.id;
    // }

    if (field.hasOwnProperty("wrappers")) {
      delete field["wrappers"];
    }

    if (field.hasOwnProperty("_keyPath")) {
      delete field["_keyPath"];
    }

    if (field.hasOwnProperty("modelOptions")) {
      delete field["modelOptions"];
    }

    if (field.hasOwnProperty("checked")) {
      delete field["checked"];
    }

    if (field.hasOwnProperty("rowNumber")) {
      delete field["rowNumber"];
    }

    if (field.hasOwnProperty("templateOptions")) {
      if (field.templateOptions.hasOwnProperty("focus")) {
        delete field.templateOptions.focus;
      }
      if (field.templateOptions.hasOwnProperty("disabled")) {
        delete field.templateOptions.disabled;
      }
      if (field.templateOptions.hasOwnProperty("readonly")) {
        delete field.templateOptions.readonly;
      }
    }

    if (field.fieldArray) {
      if (field.fieldArray.fieldGroup) {
        if (field.fieldGroup) {
          delete field.fieldGroup;
        }
        this.initFormFieldProperty(field.fieldArray.fieldGroup);
      }
    }
    if (field.fieldGroup) {
      this.initFormFieldProperty(field.fieldGroup);
    }
  }

  private setFieldsProperty(
    field: KreFormFieldConfig,
    role: any,
    option: any,
    model: any,
    caller: any,
    callback: any,
    platform: string,
    index?: number,
    isPIndex?: boolean
  ) {
    if (model === undefined || model === null) {
      model = {};
    }

    if (role && role != null) {
      if (role[field.key] !== undefined && role[field.key] !== null) {
        this.setFiledRole(
          field,
          role,
          option,
          model,
          caller,
          callback,
          platform
        );
      }
    }
    if (option && option != null) {
      if (option[field.key] !== undefined && option[field.key] !== null) {
        this.setFiledOptions(
          field,
          role,
          option,
          model,
          caller,
          callback,
          platform
        );
      }
    }

    if (model && model !== null) {
      if (field.type === "repeat") {
        if (
          !!model[field.key] &&
          Array.isArray(model[field.key]) &&
          !_.isEmpty(model[field.key])
        ) {
          (model[field.key] as any[]).forEach((el) => {
            Object.keys(el).forEach((key) => {
              field.fieldArray.fieldGroup.forEach((ele) => {
                if (key === ele.key) {
                  this.setFiledModel(
                    ele,
                    role,
                    option,
                    el,
                    caller,
                    callback,
                    platform
                  );
                }
              });
            });
          });
        }
      } else {
        this.setFiledModel(
          field,
          role,
          option,
          model,
          caller,
          callback,
          platform
        );
      }
    }

    if (field && field !== null) {
      this.setFiledEvent(
        field,
        role,
        option,
        model,
        caller,
        callback,
        platform,
        index,
        isPIndex
      );
    }
  }

  /*
    规则-设置字段属性
  */
  private setFiledRuleExecute(
    field: any,
    model: any,
    code: any,
    item: any,
    pcode?: any
  ) {
    if (field.key == code) {
      if (pcode !== undefined && pcode !== null && item.value !== undefined) {
        _.set(model, pcode + "." + code, item.value);
      } else {
        if (!!item && item.value !== undefined) {
          _.set(model, code, item.value);
        }
      }

      if (!!item && item.hasOwnProperty("show")) {
        field.show = item.show;
        field.hide = !item.show;
      }
      if (!!item && item.hasOwnProperty("editor")) {
        field.editor = item.editor;
      }
      if (
        field.templateOptions === undefined ||
        field.templateOptions === null
      ) {
        field.templateOptions = {};
      }
      if (!!item && item.hasOwnProperty("templateOptions")) {
        field.templateOptions = Object.assign(
          field.templateOptions,
          item.templateOptions
        );
      }
      if (field && field.type === "numbers") {
        if (
          field.templateOptions &&
          field.templateOptions.precision != undefined &&
          field.templateOptions.precision != null
        ) {
          if (model[field.key] != undefined && !!model[field.key]) {
            model[field.key] = _.round(
              model[field.key],
              field.templateOptions.precision
            );
          }
        }
      }
    }
    if (field.fieldArray) {
      if (field.fieldArray.fieldGroup) {
        field.fieldArray.fieldGroup.forEach((element: any) => {
          this.setFiledRuleExecute(element, model, code, item);
        });
      }
    }

    if (field.fieldGroup) {
      if (pcode === undefined || pcode === null || pcode === "") {
        pcode = field.key;
        field.fieldGroup.forEach((element: any) => {
          this.setFiledRuleExecute(element, model, code, item, pcode);
        });
      } else {
        field.fieldGroup.forEach((element: any) => {
          this.setFiledRuleExecute(
            element,
            model,
            code,
            item,
            pcode + "." + field.key
          );
        });
      }
      if ((field.fieldGroup as any[]).some((el) => !!el.fieldGroup)) {
        (field.fieldGroup as any[]).forEach((el: any) => {
          Object.keys(item).forEach((key) => {
            if (`${field.key}$${el.key}` === key) {
              if (el.fieldGroup) {
                el.fieldGroup.forEach((element: any) => {
                  for (let k in item[key]) {
                    if (!!model[field.key]) {
                      this.setFiledRuleExecute(
                        element,
                        model[field.key][Number(el.key)],
                        k,
                        item[key][k],
                        null
                      );
                    }
                  }
                });
              }
            }
          });
        });
      }
    } else {
    }
  }

  /*
    角色-设置字段属性
  */
  private setFiledRoleExecute(
    fields: any,
    model: any,
    code: any,
    item: any,
    pcode?: any
  ) {
    fields.forEach((field) => {
      if (field.key == code) {
        if (pcode != null && item.value != undefined) {
          _.set(model, pcode + "." + code, item.value);
        } else {
          if (item.value != undefined) {
            _.set(model, code, item.value);
          }
        }
        if (item.hasOwnProperty("show")) {
          field.show = item.show;
          field.hide = !item.show;
        }
        if (item.hasOwnProperty("editor")) {
          field.editor = item.editor;
        }
        if (
          field.templateOptions === undefined ||
          field.templateOptions === null
        ) {
          field.templateOptions = {};
        }
        if (item.hasOwnProperty("templateOptions")) {
          field.templateOptions = Object.assign(
            field.templateOptions,
            item.templateOptions
          );
        }
      }
      if (field.fieldArray) {
        if (field.fieldArray.fieldGroup) {
          this.setFiledRoleExecute(
            field.fieldArray.fieldGroup,
            model,
            code,
            item
          );
        }
      }
      if (field.fieldGroup) {
        if (pcode == undefined || pcode == null || pcode == "") {
          pcode = field.key;
          this.setFiledRoleExecute(field.fieldGroup, model, code, item, pcode);
        } else {
          this.setFiledRoleExecute(
            field.fieldGroup,
            model,
            code,
            item,
            pcode + "." + field.key
          );
        }
      } else {
      }
    });
  }

  /*
    设置字段角色相关的属性
  */
  private setFiledRole(
    field: any,
    role: any,
    option: any,
    model: any,
    caller: any,
    callback: any,
    platform: string
  ) {
    if (
      !Array.isArray(field) &&
      field &&
      (field.templateOptions === undefined || field.templateOptions === null)
    ) {
      field.templateOptions = {};
    }

    let item: KreFormFieldRole = role[field.key];
    if (item !== undefined && item != null) {
      if (item.hasOwnProperty("show")) {
        field.show = item.show;
        field.hide = !item.show;
      }
      if (item.hasOwnProperty("editor")) {
        field.editor = item.editor;
      }
      if (item.hasOwnProperty("className")) {
        field.className = item.className;
      }

      if (
        field.templateOptions === undefined ||
        field.templateOptions === null
      ) {
        field.templateOptions = {};
      }
      if (item.hasOwnProperty("templateOptions")) {
        field.templateOptions = Object.assign(
          field.templateOptions,
          item.templateOptions
        );
      }
    }

    if (field.fieldArray) {
      if (field.fieldArray.fieldGroup) {
        this.setFiledRole(
          field.fieldArray.fieldGroup,
          role,
          option,
          model,
          caller,
          callback,
          platform
        );
      }
    }
    if (field.fieldGroup) {
      this.setFiledRole(
        field.fieldGroup,
        role,
        option,
        model,
        caller,
        callback,
        platform
      );
    }
  }

  /*
    设置字段下拉选择options的属性
  */
  private setFiledOptions(
    field: any,
    role: any,
    option: any,
    model: any,
    caller: any,
    callback: any,
    platform: string
  ) {
    let item: KreFormFieldOption[] = option[field.key];
    if (
      !_.isEmpty(role) &&
      !_.isEmpty(role[field.key]) &&
      !_.isEmpty(role[field.key]["templateOptions"]) &&
      !_.isEmpty(role[field.key]["templateOptions"]["options"])
    ) {
      item = role[field.key]["templateOptions"]["options"];
    }
    if (item !== undefined && item !== null && Array.isArray(item)) {
      field.templateOptions.options = item;
    }
    if (field.fieldArray) {
      if (field.fieldArray.fieldGroup) {
        this.initFormFieldConfig(
          field.fieldArray.fieldGroup,
          role,
          option,
          model,
          caller,
          callback,
          platform
        );
      }
    }
    if (field.fieldGroup) {
      this.initFormFieldConfig(
        field.fieldGroup,
        role,
        option,
        model,
        caller,
        callback,
        platform
      );
    }
  }

  /*
    设置字段默认值的属性
  */
  private setFiledModel(
    field: any,
    role: any,
    option: any,
    model: any,
    caller: any,
    callback: any,
    platform: string
  ) {
    if (field && field.type === "numbers") {
      if (
        field.templateOptions &&
        field.templateOptions.precision != undefined &&
        field.templateOptions.precision != null
      ) {
        if (model[field.key] != undefined && !!model[field.key]) {
          model[field.key] = _.round(
            model[field.key],
            field.templateOptions.precision
          );
        }
      }
    }

    if (field && field.type === "datetime") {
      if (
        field.templateOptions &&
        field.templateOptions.type &&
        field.templateOptions.type === "time"
      ) {
        if (model[field.key] === undefined || model[field.key] === null) {
          if (!field.defaultValue) {
            model[field.key] = null;
          }
        } else {
          if (platform != "mobile") {
            model[field.key] = new Date(`${model[field.key]}`);
          }
        }
      }
      if (this.checkFieldDefaultValue(field)) {
        if (model[field.key] === undefined) {
          model[field.key] = field.defaultValue;
        }
      }
    }

    if (field.hasOwnProperty("editor")) {
      if (this.checkFieldDefaultValue(field)) {
        if (model[field.key] === undefined) {
          model[field.key] = field.defaultValue;
        }
      }
    }
    if (
      field.type === "panel" ||
      field.type === "tabular" ||
      field.type === "salary"
    ) {
      if (
        field.type === "tabular" &&
        (model[field.key] == undefined || model[field.key] == null)
      ) {
        model[field.key] = {};
      }
    } else {
      if (field.hasOwnProperty("fieldGroup")) {
        //初始化值
        if (!this.checkFieldDefaultValue(field) && field.type !== "group") {
          model[field.key] = {};
        }
        field.fieldGroup.forEach((fieldGroup) => {
          if (fieldGroup.hasOwnProperty("editor")) {
            if (
              !!model[field.key] &&
              !!model[field.key][fieldGroup.key] &&
              this.checkFieldDefaultValue(model[field.key][fieldGroup.key])
            ) {
              model[field.key][fieldGroup.key] = fieldGroup.defaultValue;
            }
          }
        });
      }
    }
  }

  private setFiledEvent(
    field: any,
    role: any,
    option: any,
    model: any,
    caller: any,
    callback: any,
    platform: string,
    index?: number,
    isPIndex?: boolean
  ) {
    if (isPIndex) {
      this.pIndex[field.id] = index;
    }

    if (field.key !== undefined && field.key !== null) {
      if (
        field.templateOptions !== undefined &&
        field.templateOptions !== null &&
        field.templateOptions.enableInterface !== null &&
        field.templateOptions.enableInterface === true
      ) {
        switch (field.type) {
          case "text":
          case "textarea":
          case "password":
          case "textBtn":
            field.templateOptions.blur = (e) => {
              if (e.templateOptions.index === undefined) {
                e.templateOptions.index = index;
              }
              let ind = e.templateOptions.index;
              if (
                !!e.templateOptions.pIndex ||
                e.templateOptions.pIndex === 0
              ) {
                ind = `${e.templateOptions.pIndex}-${e.templateOptions.index}`;
              }

              if (
                !!this.pIndex &&
                Object.keys(this.pIndex).length > 0 &&
                !!field.parent &&
                !!field.parent.parent &&
                (!!this.pIndex[e.parent.parent.id] ||
                  this.pIndex[e.parent.parent.id] === 0)
              ) {
                ind = `${this.pIndex[e.parent.parent.id]}-${
                  e.templateOptions.index
                }`;
              }
              this.setCallBackFun(
                caller,
                callback,
                e.formControl.value,
                field,
                ind
              );
            };
            break;
          case "checkbox":
            field.templateOptions.change = (e: any) => {
              setTimeout(() => {
                this.setCallBackFun(
                  caller,
                  callback,
                  e.formControl.value,
                  field
                );
              }, 0);
            };
            break;
          case "tabular":
          case "repeat":
            break;
          default:
            field.templateOptions.index = index;
            field.hooks = {
              onInit: (field) => {
                return field.formControl.valueChanges.pipe(
                  distinctUntilChanged(),
                  throttleTime(1000),
                  tap((e) => {
                    if (field.templateOptions.index === undefined) {
                      field.templateOptions.index = index;
                    }
                    let ind = field.templateOptions.index;

                    if (
                      !!field.templateOptions.pIndex ||
                      field.templateOptions.pIndex === 0
                    ) {
                      ind = `${field.templateOptions.pIndex}-${field.templateOptions.index}`;
                    }
                    if (
                      !!this.pIndex &&
                      Object.keys(this.pIndex).length > 0 &&
                      !!field.parent &&
                      !!field.parent.parent &&
                      (!!this.pIndex[field.parent.parent.id] ||
                        this.pIndex[field.parent.parent.id] === 0)
                    ) {
                      ind = `${this.pIndex[field.parent.parent.id]}-${
                        field.templateOptions.index
                      }`;
                    }

                    this.setCallBackFun(caller, callback, e, field, ind);
                  })
                );
              },
            };
            break;
        }
      }
    }

    if (field.fieldArray) {
      if (field.fieldArray.fieldGroup) {
        this.initFormFieldConfig(
          field.fieldArray.fieldGroup,
          role,
          option,
          model,
          caller,
          callback,
          platform
        );
      }
    }
    setTimeout(() => {
      if (field.fieldGroup) {
        (field.fieldGroup as any[]).forEach((el: any, index: number) => {
          let isPIndex = false;
          if (
            !!el.fieldGroup &&
            (el.fieldGroup as any[]).some((el) => el.type === "repeat")
          ) {
            isPIndex = true;
          }

          this.initFormFieldConfig(
            el.fieldGroup,
            role,
            option,
            model,
            caller,
            callback,
            platform,
            index,
            isPIndex
          );
        });
      }
    }, 0);
    if (field.fieldGroup) {
      this.initFormFieldConfig(
        field.fieldGroup,
        role,
        option,
        model,
        caller,
        callback,
        platform
      );
    }
  }
  private setFieldNumber(surveyInfo: any, fields: KreFormFieldConfig[]) {
    fields.forEach((field: KreFormFieldConfig) => {
      if (field.type != "line" && field.type != "remark") {
        surveyInfo.queTotal = surveyInfo.queTotal + 1;
        field.templateOptions.queno = "Q" + surveyInfo.queTotal;
      }
    });
  }
  private setCallBackFun(
    caller: any,
    callback: any,
    e: any,
    field: any,
    index?: number
  ) {
    if (typeof e == "boolean" || typeof e == "number" || typeof e == "string") {
      if (callback != undefined && callback != null && callback != "") {
        callback.call(caller, e, field, index);
      }
    } else {
      /*
      if (e != null && e != "") {
        if (Array.isArray(e)) {
          if (e.length == 0) {
            return;
          }
        }
        if (callback != undefined && callback != null && callback != "") {
          callback.call(caller, e, field);
        }
      }
      */
      if (callback != undefined && callback != null && callback != "") {
        callback.call(caller, e, field, index);
      }
    }
  }
}
